module.exports = __webpack_public_path__ + "static/media/noimage.1cb056ae.jpg";